import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { BrandState } from "models/brand";

const initialState: BrandState = {
  imgloading: false,
  loading: false,
  brandLoading: false,
  data: {},
  message: "",
  success: false,
  imageUrl: "",
  updateMessage: "",
  addBrandLoading: false,
  addUpdateBrandLoading: false,
  brandByIdLoading: false,
  brandByIdSuccess: false,
  allBrandListLoading: false,
  brandByIdData: {},
  customerdata: {},
  mainBrands: [],
  deleteLoading: false,

  brandLocationLoading: false,
  brandLocationData: {},
  brandLocationMessage: "",
  brandLocationSuccess: false,

  multiStoreKotLoading: false,
  multiStoreKotMessage: "",
  multiStoreKotSuccess: false,

  kotConfigsLoading: false,
  kotConfigsData: {},
  kotConfigsMessage: "",
  kotConfigsSuccess: false,

  locationsAndStoresLoading: false,
  locationsAndStoresData: {},
  locationsAndStoresSuccess: false,
  locationsAndStoresMessage: "",
};

const brandSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    getBrands(state, action: PayloadAction<ApiResponse>) {
      state.brandLoading = true;
      state.message = "";
    },
    getBrandSuccess(state, action: PayloadAction<ApiResponse>) {
      state.brandLoading = false;
      state.data = action.payload;
      state.success = action.payload?.success;
    },
    getBrandFailed(state, action: PayloadAction<ApiResponse>) {
       state.brandLoading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getLocationsAndStoresByBrand(state, action: PayloadAction<ApiResponse>) {
      state.locationsAndStoresLoading = true;
      state.locationsAndStoresMessage = "";
    },
    getLocationsAndStoresByBrandSuccess(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.locationsAndStoresLoading = false;
      state.locationsAndStoresData = action.payload.data;
      state.locationsAndStoresSuccess = action.payload?.success;
    },
    getLocationsAndStoresByBrandFailed(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.locationsAndStoresloading = false;
      state.locationsAndStoresMessage = action.payload?.message;
      state.locationsAndStoresSuccess = action.payload?.success;
    },
    getBrandbyId(state, action: PayloadAction<ApiResponse>) {
      state.brandByIdLoading = true;
      state.brandByIdSuccess = false;
      state.brandByIdData = {};
    },
    getBrandbyIdSuccess(state, action: PayloadAction<ApiResponse>) {
      state.brandByIdLoading = false;
      state.brandByIdData = action.payload?.brandData;
      state.brandByIdSuccess = action.payload?.success;
    },
    getBrandbyIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.brandByIdLoading = false;
      state.brandByIdData = action.payload?.data;
      state.brandByIdSuccess = action.payload?.success;
    },
    clearBrandbyIdSuccess(state) {
      state.brandByIdLoading = false;
      state.brandByIdSuccess = false;
    },
    getCustomersList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.customerdata = {};
      state.message = "";
    },
    getCustomersListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.customerdata = action.payload;
      state.success = action.payload?.success;
    },
    getCustomersListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    addBrand(state, action: PayloadAction<ApiResponse>) {
      state.addBrandLoading = true;
      state.message = "";
    },
    addBrandSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addBrandLoading = false;
      state.message = action.payload?.message || "";
      state.success = action.payload?.success || false;
    },
    addBrandFailed(state, action: PayloadAction<ApiResponse>) {
      state.addBrandLoading = false;
      state.message = action.payload?.message || "Operation failed";
      state.success = action.payload?.success || false;
    },
    updateBrand(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateBrandLoading = true;
      state.message = "";
    },
    updateBrandSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateBrandLoading = false;
      state.message = action.payload?.message || "";
      state.success = action.payload?.success || false;
    },
    updateBrandFailed(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateBrandLoading = false;
      state.message = action.payload?.message || "Operation failed";
      state.success = action.payload?.success || false;
    },
    addOrUpdateMultiStoreKotConfig(state, action: PayloadAction<any>) {
      state.multiStoreKotLoading = true;
      state.multiStoreKotMessage = "";
      state.multiStoreKotSuccess = false;
    },
    addOrUpdateMultiStoreKotConfigSuccess(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.multiStoreKotLoading = false;
      state.multiStoreKotMessage = action.payload?.message || "";
      state.multiStoreKotSuccess = action.payload?.success || false;
    },
    addOrUpdateMultiStoreKotConfigFailed(
      state,
      action: PayloadAction<ApiResponse>
    ) {
      state.multiStoreKotLoading = false;
      state.multiStoreKotMessage = action.payload?.message || "Operation failed";
      state.multiStoreKotSuccess = action.payload?.success || false;
    },

    getMainBrands(state) {
      state.allBrandListLoading = true;
      state.message = "";
    },
    getMainBrandSuccess(state, action: PayloadAction<ApiResponse>) {
      state.allBrandListLoading = false;
      state.mainBrands = action.payload;
      state.success = action.payload.success;
    },
    getMainBrandsFailed(state, action: PayloadAction<ApiResponse>) {
      state.allBrandListLoading = false;
      state.message = action.payload?.message || "Failed to fetch brands";
      state.success = action.payload?.success || false;
    },
    deleteBrand(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = true;
      state.message = "";
    },
    deleteBrandSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.message = action.payload?.message || "";
      state.success = action.payload?.success || false;
    },
    deleteBrandFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.message = action.payload?.message || "Operation failed";
      state.success = action.payload?.success || false;
    },
    getImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = true;
      state.imageUrl = "";
    },
    getImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = false;
      state.imageUrl = action.payload.photoURL;
    },
    getImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = false;
      state.imageUrl = "";
    },
    changeBrandStatus(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    changeBrandStatusSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message || "";
      state.success = action.payload?.success || false;
    },
    changeBrandStatusFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.mesage = action.payload?.message || "Operation failed";
      state.success = action.payload?.success || false;
    },
    getBrandLocation(state, action: PayloadAction<string>) {
      state.brandLocationLoading = true;
      state.brandLocationData = {};
      state.brandLocationMessage = "";
      state.brandLocationSuccess = false;
    },
    getBrandLocationSuccess(state, action: PayloadAction<ApiResponse>) {
      state.brandLocationLoading = false;
      state.brandLocationData = action.payload;
      state.brandLocationMessage = action.payload?.message;
      state.brandLocationSuccess = action.payload?.success;
    },
    getBrandLocationFailed(state, action: PayloadAction<ApiResponse>) {
      state.brandLocationLoading = false;
      state.brandLocationData = {};
      state.brandLocationMessage = action.payload?.message;
      state.brandLocationSuccess = action.payload?.success;
    },
    clearBrandLocation(state) {
      state.brandLocationLoading = false;
      state.brandLocationData = {};
      state.brandLocationMessage = "";
      state.brandLocationSuccess = false;
    },
    getKotConfigs(state, action: PayloadAction<string>) {
      state.kotConfigsLoading = true;
      state.kotConfigsData = {};
      state.kotConfigsMessage = "";
      state.kotConfigsSuccess = false;
    },
    getKotConfigsSuccess(state, action: PayloadAction<ApiResponse>) {
      state.kotConfigsLoading = false;
      state.kotConfigsData = action.payload;
      state.kotConfigsMessage = action.payload?.message;
      state.kotConfigsSuccess = action.payload?.success;
    },
    getKotConfigsFailed(state, action: PayloadAction<ApiResponse>) {
      state.kotConfigsLoading = false;
      state.kotConfigsData = {};
      state.kotConfigsMessage = action.payload?.message;
      state.kotConfigsSuccess = action.payload?.success;
    },
    clearKotConfigs(state) {
      state.kotConfigsLoading = false;
      state.kotConfigsData = {};
      state.kotConfigsMessage = "";
      state.kotConfigsSuccess = false;
    },

    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.updateMessage = "";
      state.deleteMessage = "";
      state.imageUrl = "";
    },
  },
});

//Actions
export const brandActions = brandSlice.actions;

//Selectors
export const getBrandsData = (state: RootState) => state.brands.data;
export const getLocationsAndStoresByBrandData = (state: RootState) =>
  state.brands.locationsAndStoresData;
export const getLocationsAndStoresByBrandLoading = (state: RootState) =>
  state.brands.locationsAndStoresLoading;
export const getLocationsAndStoresByBrandSuccess = (state: RootState) =>
  state.brands.locationsAndStoresSuccess;
export const getMainBrandsList = (state: RootState) => state.brands.mainBrands;
export const getAllBrandsLoading = (state: RootState) => state.brands.allBrandListLoading;

export const getBrandById = (state: RootState) => state.brands.brandByIdData;
export const getBrandByIdLoading = (state: RootState) =>
  state.brands.brandByIdLoading;
export const getBrandByIdSuccess = (state: RootState) =>
  state.brands.brandByIdSuccess;
export const getCustomerData = (state: RootState) => state.brands.customerdata;
export const imageLoading = (state: RootState) => state.brands.imgloading;
export const selectIsLoading = (state: RootState) => state.brands.loading;
export const selectIsBrandLoader = (state: RootState) => state.brands.brandLoading;
export const selectIsBrandLoading = (state: RootState) => state.brands.loading;
export const addBrandIsLoading = (state: RootState) =>
  state.brands.addBrandLoading;
export const addUpdateBrandIsLoading = (state: RootState) =>
  state.brands.addUpdateBrandLoading;
export const selectIsSuccess = (state: RootState) => state.brands.success;
export const selectMessage = (state: RootState) => state.brands.message;
export const selectImageUrl = (state: RootState) => state.brands.imageUrl;
export const selectUpdateMessage = (state: RootState) =>
  state.brands.updateMessage;
export const selectDeleteLoading = (state: RootState) =>
  state.brands.deleteLoading;
export const getBrandLocationData = (state: RootState) =>
  state.brands.brandLocationData;
export const getBrandLocationLoading = (state: RootState) =>
  state.brands.brandLocationLoading;
export const getBrandLocationMessage = (state: RootState) =>
  state.brands.brandLocationMessage;
export const getBrandLocationSuccess = (state: RootState) =>
  state.brands.brandLocationSuccess;
export const getMultiStoreKotLoading = (state: RootState) =>
  state.brands.multiStoreKotLoading;

export const getMultiStoreKotMessage = (state: RootState) =>
  state.brands.multiStoreKotMessage;

export const getMultiStoreKotSuccess = (state: RootState) =>
  state.brands.multiStoreKotSuccess;
export const getKotConfigsData = (state: RootState) =>
  state.brands.kotConfigsData;
export const getKotConfigsLoading = (state: RootState) =>
  state.brands.kotConfigsLoading;
export const getKotConfigsMessage = (state: RootState) =>
  state.brands.kotConfigsMessage;
export const getKotConfigsSuccess = (state: RootState) =>
  state.brands.kotConfigsSuccess;

//Reducers
const brandReducer = brandSlice.reducer;
export default brandReducer;
